//
//
//
//
//
//
//

export default {
  props: [
    'text',
    'subTitle'
  ],
  mounted() {
    // 监听滚动事件
  }
}



// WEBPACK FOOTER //
// ./src/components/Title/Title.vue